/**
 * Accordion utilities -- Currently used on the new style VDP's
 */
((document) => {
  try {
    // Get all the accordions
    const accordionContainers = document.querySelectorAll('.js-accordions');

    accordionContainers.forEach((container) => {
      const accordions = container.querySelectorAll('.accordion');
      // Create the DOM elements we need
      const accordionContainerFragment = new DocumentFragment();
      const accordionDivContainer = document.createElement('div');
      const leftContainer = document.createElement('div');
      const rightContainer = document.createElement('div');

      // Add the classes
      accordionDivContainer.classList.add(
        'vehicle-landing-page-accordions',
        'accordions--two-column',
      );
      leftContainer.classList.add('accordions-two-column--left-column');
      rightContainer.classList.add('accordions-two-column--right-column');

      // Loop through the accordion items and split them into two
      // divs so we can manipulate them
      accordions.forEach((accordion, i) => {
        const accordionDiv = document.createElement('div');
        accordionDiv.classList.add('accordion');
        accordionDiv.innerHTML = accordion.innerHTML;
        if (i % 2 === 0) {
          rightContainer.appendChild(accordionDiv);
        } else {
          leftContainer.appendChild(accordionDiv);
        }
      });

      // Append the filtered accordions and their divs to
      // the fragment and to the DOM
      accordionDivContainer.appendChild(leftContainer);
      accordionDivContainer.appendChild(rightContainer);
      accordionContainerFragment.appendChild(accordionDivContainer);
      container.parentNode.replaceChild(accordionContainerFragment, container);
    });
  } catch (err) {
    console.warn(err);
  }
})(document);
